<div class="store android">
  <a class="appStoreButton androidButton" href="https://play.google.com/store/apps/details?id=com.traviangames.arkheim" angulartics2On="click" angularticsAction="downloadAndroid" angularticsCategory="download">
    <img alt="Get it on Google Play" src="assets/appStoreButtons/android/Get_it_on_Google_Play_EN.png" width="250">
  </a>
</div>